module.exports = __webpack_public_path__ + "img/info_06.ddec8746.png";